export var AccountStatuses = {
    UNPAID: 1,
    PAID: 2,
    PAYMENT_FAILED: 3,
    CANCELLED: 4
};
export var ActionTypes = {
    CLOSE_MODAL: 'CLOSE_MODAL',
    OPEN_MODAL: 'OPEN_MODAL',
    SHOW_PAYWALL: 'SHOW_PAYWALL',
    HIDE_PAYWALL: 'HIDE_PAYWALL',
    SHOW_GLOBAL_LOADER: 'SHOW_GLOBAL_LOADER',
    HIDE_GLOBAL_LOADER: 'HIDE_GLOBAL_LOADER',
    UPDATE_FORM_STATE: 'UPDATE_FORM_STATE',
    UPDATE_COMPANY_STORE: 'UPDATE_COMPANY_STORE',
    LOGIN: 'LOGIN',
    LOGOUT: 'LOGOUT',
    ADD_PRODUCT: 'ADD_PRODUCT',
    UPDATE_ACCOUNT: 'UPDATE_ACCOUNT',
    UPDATE_PRODUCT: 'UPDATE_PRODUCT',
    UPDATE_PLAYER: 'UPDATE_PLAYER',
    UPDATE_TEAM: 'UPDATE_TEAM',
    UPDATE_GOAL: 'UPDATE_GOAL',
    SET_CLIENT_KEY: 'SET_CLIENT_KEY',
    DELETE_CLIENT_KEY: 'DELETE_CLIENT_KEY',
    FETCH_GAME: 'FETCH_GAME',
    DELETE_GAME: 'DELETE_GAME',
    UPDATE_NOTIFICATION: 'UPDATE_NOTIFICATION',
    CHANGE_GAME_ACCOUNT_STATUS: 'CHANGE_GAME_ACCOUNT_STATUS',
    UPDATE_GAME_TRACKABLE_MAPPING: 'UPDATE_GAME_TRACKABLE_MAPPING',
    UPDATE_USER_NOTIFICATIONS: 'UPDATE_USER_NOTIFICATIONS',
    SET_USER_NOTIFICATIONS_LOADING: 'SET_USER_NOTIFICATIONS_LOADING',
    SET_GAME_NOTIFICATIONS: 'SET_GAME_NOTIFICATIONS',
    UPDATE_CLIENT_STORE: 'UPDATE_CLIENT_STORE'
};
export var DataUpdateTimeout = 1000;
export var DataStaleDurationSeconds = 300;
export var DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss';
export var DaysInFreeTrial = 30;
export var DraggableTypes = {
    TRACKABLE: 'TRACKABLE'
};
export var FreeTrialCutoffAccountId = 4059;
export var FormSuccessTimeout = 2;
export var GamesAccountStatuses = {
    INVITED: 1,
    ACCEPTED: 2,
    DECLINED: 3,
    REMOVED: 4,
    SPECTATOR: 5
};
export var GameMemberTypeMap = {
    PLAYERS: 1,
    TEAMS: 2
};
export var GameTypeMap = {
    CLASSIC: 1,
    FREE_FOR_ALL: 2
};
export var GameFrequencyMap = {
    DAILY: 1,
    WEEKLY: 2,
    MONTHLY: 3,
    YEARLY: 4,
    NOT_REPEATING: 5
};
export var GameModes = {
    STANDARD: 1,
    COUNTDOWN: 2
};
export var GoalFrequencies = {
    DAILY: 1,
    WEEKLY: 2,
    MONTHLY: 3,
    YEARLY: 4
};
export var LocalStorageKeys = {
    HIDE_COMPETITION_ANNOUNCEMENT: 'hide_competition_announcement'
};
export var NotificationMessageTypes = {
    GENERIC: 1,
    GAME_INVITE: 2,
    GAME_ADDED: 3
};
export var NotificationStatusMap = {
    NOTIFICATION_STATUS_UNREAD: 1,
    NOTIFICATION_STATUS_DISMISSED: 2,
    NOTIFICATION_STATUS_DELETED: 3
};
export var NotificationTypes = {
    INFO: 'info',
    WARNING: 'warning',
    ERROR: 'error',
    SUCCESS: 'success'
};
export var PickerTypes = {
    PLAYERS: 1,
    TEAMS: 2
};
export var PrivacySettings = {
    PRIVATE: 1,
    PUBLIC: 2
};
export var Roles = {
    ADMINISTRATOR: 1,
    SALESPERSON: 2
};
export var SubscriptionTiers = {
    FREE: 'Free',
    BASIC: 'Basic',
    BUSINESS: 'Business'
};
export var TrackableModes = {
    QUANTITY: 1,
    VALUE: 2
};
export var TrackableModesByValue = {
    1: 'QUANTITY',
    2: 'VALUE'
};
export var UploadTypes = {
    UPLOAD_TYPE_LOGO: 1,
    UPLOAD_TYPE_COVER_PHOTO: 2,
    UPLOAD_TYPE_USER: 3,
    UPLOAD_TYPE_TEAM: 4,
    UPLOAD_TYPE_GAME: 5
};
export default {
    AccountStatuses: AccountStatuses,
    ActionTypes: ActionTypes,
    DataUpdateTimeout: DataUpdateTimeout,
    DataStaleDurationSeconds: DataStaleDurationSeconds,
    DATE_FORMAT: DATE_FORMAT,
    DaysInFreeTrial: DaysInFreeTrial,
    DraggableTypes: DraggableTypes,
    FreeTrialCutoffAccountId: FreeTrialCutoffAccountId,
    FormSuccessTimeout: FormSuccessTimeout,
    GamesAccountStatuses: GamesAccountStatuses,
    GameMemberTypeMap: GameMemberTypeMap,
    GameTypeMap: GameTypeMap,
    GameFrequencyMap: GameFrequencyMap,
    GameModes: GameModes,
    GoalFrequencies: GoalFrequencies,
    LocalStorageKeys: LocalStorageKeys,
    NotificationMessageTypes: NotificationMessageTypes,
    NotificationTypes: NotificationTypes,
    PickerTypes: PickerTypes,
    PrivacySettings: PrivacySettings,
    Roles: Roles,
    TrackableModes: TrackableModes,
    TrackableModesByValue: TrackableModesByValue,
    UploadTypes: UploadTypes
};
